export default "__VITE_ASSET__DVnkl0Ms__"